module.exports = __webpack_public_path__ + "img/es.a391aea2.svg";